import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { giftLectureSearchModule } from "./helpAndAssistantApi";

export interface GiftLectureSearchState {
  giftLectureSearch: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: GiftLectureSearchState = {
  giftLectureSearch: [],
  status: "idle",
};

export const GetgiftLectureSearch = createAsyncThunk(
  "giftLectureSearch/fetchgiftLectureSearch",
  async (data:any) => {
    const response = await giftLectureSearchModule(data);
    return response;
  }
);

export const giftLectureSearchSlice = createSlice({
  name: "giftLectureSearch",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetgiftLectureSearch.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetgiftLectureSearch.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(GetgiftLectureSearch.fulfilled, (state, action) => {
        state.status = "idle";
        state.giftLectureSearch = action.payload;
        
      });
  },
});

export const {} = giftLectureSearchSlice.actions;

export const selectgiftLectureSearch = (state: RootState) => {
  return state.GiftLectureSearch.giftLectureSearch;
};

export default giftLectureSearchSlice.reducer;